import timecrunchScreenshot from "../assets/timecrunch-screenshot-2.png";
import inappScreenshot from "../assets/in-app-notification-screenshot.png";
import emailScreenshot from "../assets/email-notification-screenshot.png";
import { motion } from "framer-motion";
import useMediaQuery from "../hooks/useMediaQuery";

const Features = () => {
    // Use a media query hook to determine if we're on a small screen.
    const isMobile = useMediaQuery("(max-width: 768px)");
    const isAboveMd = useMediaQuery("(min-width: 768px)")
    const isExtraSmall = useMediaQuery("(max-width: 425px)")

    // Define grid styles based on screen size.
    const gridStyle = isMobile
        ? {
            display: "grid",
            gridTemplateAreas: `
          "screenshot"
          "feature3"
          "feature2"
          "feature4"
          "feature6"
        `,
            gridTemplateColumns: "1fr",
            gridAutoRows: "auto",
            gap: isMobile? "5px": "20px",
            alignItems: "center",
            width: "100%",
        }
        : {
            display: "grid",
            gridTemplateAreas: `
          "feature3 screenshot feature2"
          "feature3 screenshot feature4"
          "feature6 feature6 feature6"
        `,
            gridTemplateColumns: "1fr auto 1fr",
            gridTemplateRows: "1fr 1fr",
            gap: "20px",
            alignItems: "center",
            width: "100%",
        };

    return (
        <section
            id="features"
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                boxSizing: "border-box",
                fontFamily: "Montserrat, sans-serif",
            }}
        >
            <h1
                style={{
                    fontSize: isMobile ? "2rem": "3rem",
                    textAlign: "center",
                    marginBottom: isMobile? "10px": "40px",
                    color: "rgb(45, 45, 45)",
                }}
            >
                Explore TimeCrunch Features
            </h1>
            <div style={gridStyle}>
                {/* Feature 2 (positioned as feature3 in desktop layout) */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, x: -100 },
                        visible: { opacity: 1, x: 0 },
                    }}
                    style={{
                        gridArea: "feature3",
                        padding: "10px",
                        background:
                            "linear-gradient(to right, rgb(127 245 57), rgb(45, 212, 191))",
                        boxShadow: "inset 0 0 12px 12px white, inset 0 0 3px 2px white",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontSize: isMobile? "0.75rem": "1rem"
                    }}
                >
                    <div
                        style={{
                            background: "white",
                            borderRadius: "8px",
                            width: "100%",
                            padding: isMobile ? "1px": "10px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <h3 style={{ margin: "10px 0" }}>Get Notifications</h3>
                        <p>
                            Receive in-app or email notifications for match updates.
                        </p>
                        <p style={{ margin: "10px 0" }}>
                            Click once for an INAPP notification
                        </p>
                        {!isMobile && (<img src={inappScreenshot} alt="Inapp Screenshot" />)}

                        <p style={{ margin: "10px 0" }}>
                            Click a second time to receive an Email when the match is finished processing
                        </p>
                        {!isMobile && (<img src={emailScreenshot} alt="Email Screenshot" />)}

                    </div>
                </motion.div>
                {/* Feature 1 (positioned as feature2 in desktop layout) */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, x: 100 },
                        visible: { opacity: 1, x: 0 },
                    }}
                    style={{
                        gridArea: "feature2",
                        padding: "10px",
                        background:
                            "linear-gradient(to right, rgb(127 245 57), rgb(45, 212, 191))",
                        boxShadow: "inset 0 0 12px 12px white, inset 0 0 3px 2px white",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontSize: isMobile? "0.75rem": "1rem"
                    }}
                >
                    <div
                        style={{
                            background: "white",
                            borderRadius: "8px",
                            width: "100%",
                            padding: "10px",
                        }}
                    >
                        <h3 style={{ margin: "10px 0" }}>Track Matches</h3>
                        <p>
                            See which matches are available or currently being processed.
                        </p>
                    </div>
                </motion.div>
                {/* Feature 3 (positioned as feature6 in desktop layout) */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, y: 100 },
                        visible: { opacity: 1, y: 0 },
                    }}
                    style={{
                        gridArea: "feature6",
                        padding: "10px",
                        background:
                            "linear-gradient(to right, rgb(127 245 57), rgb(45, 212, 191))",
                        boxShadow: "inset 0 0 12px 12px white, inset 0 0 3px 2px white",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontSize: isMobile? "0.75rem": "1rem"
                    }}
                >
                    <div
                        style={{
                            background: "white",
                            borderRadius: "8px",
                            width: "100%",
                            padding: "10px",
                        }}
                    >
                        <h3 style={{ margin: "10px 0" }}>Save Time</h3>
                        <p>
                            TimeCrunch lets you know how long condensed matches will take to watch.
                        </p>
                    </div>
                </motion.div>
                {/* Feature 4 (positioned as feature4 in desktop layout) */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    variants={{
                        hidden: { opacity: 0, x: 100 },
                        visible: { opacity: 1, x: 0 },
                    }}
                    style={{
                        gridArea: "feature4",
                        padding: "10px",
                        background:
                            "linear-gradient(to right, rgb(127 245 57), rgb(45, 212, 191))",
                        boxShadow: "inset 0 0 12px 12px white, inset 0 0 3px 2px white",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontSize: isMobile? "0.75rem": "1rem"
                    }}
                >
                    <div
                        style={{
                            background: "white",
                            borderRadius: "8px",
                            width: "100%",
                            padding: "10px",
                        }}
                    >
                        <h3 style={{ margin: "10px 0" }}>Start Watching</h3>
                        <p>
                            Match cards will navigate to your preferred streaming service seamlessly.
                        </p>
                    </div>
                </motion.div>
                {/* Center Screenshot */}
                {!isMobile && (
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, y: -100 },
                            visible: { opacity: 1, y: 0 },
                        }}
                        style={{
                            gridArea: "screenshot",
                            textAlign: "center",
                            backgroundColor: "white",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "8px",
                            padding: "20px",
                        }}
                    >
                        <img
                            src={timecrunchScreenshot}
                            alt="Screenshot"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                borderRadius: "8px",
                            }}
                        />
                    </motion.div>
                )}
            </div>
        </section>
    );
};

export default Features;
